module.exports = __webpack_public_path__ + "img/cerita_tokohaypeng.b2111f62.png";